import { RelodeApiError } from "../../../../";
import {
    MessageBoxOptionsEnum,
    MessageSearchCriteria,
    MessageSearchResults,
} from "../../types";

export interface MessageListingState {
    loadingMessages: boolean;
    error?: RelodeApiError;
    searchCriteria: MessageSearchCriteria;
    searchResults: MessageSearchResults;
    settingMessageRead: boolean;
    settingMessageUnread: boolean;
    selectedMessages: number[];
    querySetCriteria: boolean;
}

export const initialMessageListingState: MessageListingState = {
    loadingMessages: false,
    searchCriteria: {
        searchText: "",
        pageIndex: 1,
        pageSize: 25,
        sortField: "createTimestamp",
        sortDir: "desc",
        box: MessageBoxOptionsEnum.Inbox.name,
    },
    searchResults: ({} as Partial<MessageSearchResults>) as Required<MessageSearchResults>,
    settingMessageRead: false,
    settingMessageUnread: false,
    selectedMessages: [],
    querySetCriteria: false,
};
